// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../provider/Context.bs.js";
import * as Atom_Cta from "../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../atom/Atom_Row.bs.js";
import * as Atom_Cell from "../atom/Atom_Cell.bs.js";
import * as Atom_Logo from "../atom/Atom_Logo.bs.js";
import * as Atom_Text from "../atom/Atom_Text.bs.js";
import * as Atom_Image from "../atom/Atom_Image.bs.js";
import * as Atom_Column from "../atom/Atom_Column.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_Common from "../../type/Type_Common.bs.js";
import * as Type_String from "../../type/Type_String.bs.js";
import * as Type_Teaser from "../../type/Type_Teaser.bs.js";
import * as Atom_Text_Ds from "../atom/Atom_Text_Ds.bs.js";
import * as User_Observable from "../../user/User_Observable.bs.js";
import * as Molecule_Sticker from "./Molecule_Sticker.bs.js";
import * as UseTrackingPixel from "../../hook/UseTrackingPixel.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Atom_FavoriteButton from "../atom/Atom_FavoriteButton.bs.js";
import * as Molecule_TopTeaser_Ds from "./Molecule_TopTeaser_Ds.bs.js";
import * as Molecule_TopTeaser_Css from "./Molecule_TopTeaser_Css.bs.js";
import * as Particle_Accessibility from "../particle/Particle_Accessibility.bs.js";
import * as Particle_Screen_Constants from "../particle/Particle_Screen_Constants.bs.js";

var playButtonId = "next_main";

function Molecule_TopTeaser$Image(Props) {
  var srcs = Props.srcs;
  var alt = Props.alt;
  var animation = Props.animation;
  var image = function (display, style) {
    var tmp = {
      alt: Belt_Option.getWithDefault(alt, ""),
      display: display,
      identifier: "image-element",
      kind: /* Gradient */1,
      src: srcs,
      style: style
    };
    if (animation !== undefined) {
      tmp.animation = Caml_option.valFromOption(animation);
    }
    return React.createElement(Atom_Image.make, tmp);
  };
  return React.createElement(Atom_Row.make, {
              children: React.createElement(Atom_Cell.make, {
                    width: Molecule_TopTeaser_Css.$$Image.width,
                    height: Particle_Screen_Constants.oneHundredPctHeight,
                    children: null,
                    rules: Molecule_TopTeaser_Css.$$Image.rulesAspectRatio
                  }, image(Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, "none"), /* TopTeaser */18), image(Particle_Screen_Ds.make(undefined, undefined, "none", undefined, undefined, "flex"), /* TopSquareTeaser */17)),
              justifyContent: Molecule_TopTeaser_Css.$$Image.justifyContent,
              maxHeight: Particle_Screen_Constants.oneHundredPctMaxHeight,
              rules: Molecule_TopTeaser_Css.$$Image.Container.rules,
              width: Particle_Screen_Constants.oneHundredPctWidth
            });
}

var $$Image = {
  make: Molecule_TopTeaser$Image
};

function Molecule_TopTeaser(Props) {
  var elementsAnimation = Props.elementsAnimation;
  var pageKind = Props.pageKind;
  var teaser = Props.teaser;
  var styleOpt = Props.style;
  var trailerUrl = Props.trailerUrl;
  var style = styleOpt !== undefined ? styleOpt : Molecule_TopTeaser_Ds.makeDefault;
  var match = Context.I18n.getState(undefined);
  var labels = match.labels;
  var minutesLabel = labels.teaser.durationUnit;
  var trailerButton = labels.program.trailer_button;
  var title = teaser.title;
  var subtitle = teaser.subtitle;
  var kind = teaser.kind;
  var duration = teaser.duration;
  var description = teaser.description;
  var watchTrailer = match.formaters.watchTrailer;
  var match$1 = Molecule_TopTeaser_Ds.view(style);
  var idString = Curry._1(Type_String.Teaser.Id.toString, teaser.id);
  var availabilityType = Belt_Option.map(teaser.availability, (function (param) {
          return param.type_;
        }));
  var progression = Type_Common.Progression.getPct(Curry._1(User_Observable.Progression.Hook.use, teaser.dsId));
  var teaserKind = React.useMemo((function () {
          var match = Type_Teaser.Kind.view(kind);
          if (typeof match === "object") {
            if (progression !== undefined) {
              return {
                      NAME: "Progress",
                      VAL: progression
                    };
            } else {
              return "Standard";
            }
          } else if (match === "PrimeTime") {
            return "PrimeTime";
          } else if (match === "Direct") {
            return "Direct";
          } else if (match === "Live") {
            return "Live";
          } else if (progression !== undefined) {
            return {
                    NAME: "Progress",
                    VAL: progression
                  };
          } else {
            return "Standard";
          }
        }), [
        kind,
        progression
      ]);
  var progression$1 = typeof teaserKind === "object" && teaserKind.NAME === "Progress" ? teaserKind.VAL : undefined;
  var match$2 = labels.teasers;
  var labels$1;
  var exit = 0;
  if (availabilityType !== undefined) {
    if (availabilityType === "LIVESTREAM_TV") {
      labels$1 = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(match$2.watchLive), undefined, undefined, match$2.live);
    } else if (availabilityType === "LIVESTREAM_WEB") {
      labels$1 = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(match$2.watchLivestream), undefined, undefined, match$2.livestream);
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    labels$1 = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, match$2.watch);
  }
  var handleClick = UseTrackingPixel.make(Belt_Option.flatMap(teaser.trackingPixel, Type_String.TrackingPixel.toTypeUrl));
  var trailerScreenReadersLabel;
  if (title !== undefined) {
    switch (title.TAG | 0) {
      case /* AccessibilityOnly */1 :
          trailerScreenReadersLabel = title._0;
          break;
      case /* Displayed */0 :
      case /* HoverOnly */2 :
          trailerScreenReadersLabel = undefined;
          break;
      
    }
  } else {
    trailerScreenReadersLabel = undefined;
  }
  var alt = Belt_Option.map(trailerScreenReadersLabel, Type_String.Teaser.Title.toString);
  var favoriteAvailability = Atom_FavoriteButton.availabilityFromTeaserFavorite(teaser.favoriteStatus);
  var match$3 = teaser.title;
  var favoriteTitle;
  if (match$3 !== undefined) {
    switch (match$3.TAG | 0) {
      case /* Displayed */0 :
          favoriteTitle = match$3._0;
          break;
      case /* AccessibilityOnly */1 :
      case /* HoverOnly */2 :
          favoriteTitle = undefined;
          break;
      
    }
  } else {
    favoriteTitle = undefined;
  }
  var favoriteButton = React.createElement(Atom_FavoriteButton.make, {
        teaser: teaser,
        styleVariation: /* TopTeaser */2,
        title: favoriteTitle,
        availability: favoriteAvailability
      });
  var ariaLabelledby = Particle_Accessibility.AriaLabelledby.make(idString);
  var accessibility = Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(ariaLabelledby), undefined, undefined, undefined, undefined, undefined, undefined);
  var trailerButton$1;
  if (trailerUrl !== undefined) {
    var tmp = {
      href: Curry._1(Type_String.Href.toString, trailerUrl),
      label: trailerButton,
      style: {
        TAG: /* Trailer */24,
        _0: /* Enabled */0,
        _1: /* TopTeaser */1
      }
    };
    var tmp$1 = Belt_Option.map(trailerScreenReadersLabel, (function (title) {
            return Curry._1(watchTrailer, Curry._1(Type_String.Teaser.Title.toString, title));
          }));
    if (tmp$1 !== undefined) {
      tmp.screenReadersLabel = tmp$1;
    }
    trailerButton$1 = React.createElement(Atom_Cta.Link.make, tmp);
  } else {
    trailerButton$1 = null;
  }
  var buttons = React.createElement(Atom_Row.make, {
        alignItems: Molecule_TopTeaser_Css.alignItems,
        children: null,
        gap: Molecule_TopTeaser_Css.ButtonsChildrenRow.gap,
        justifyContent: Molecule_TopTeaser_Css.justifyContent
      }, React.createElement(Atom_Cta.Link.Responsive.make, {
            accessibility: accessibility,
            dataAnchor: true,
            href: Curry._1(Type_String.Href.toString, teaser.href),
            id: playButtonId,
            labelId: Particle_Accessibility.AriaLabelledby.newId(ariaLabelledby, "-play"),
            labels: labels$1,
            onClick: handleClick,
            style: {
              TAG: /* TopTeaser */23,
              _0: progression$1
            }
          }), trailerButton$1, favoriteButton);
  var logo = pageKind === 0 ? null : React.createElement(Atom_Logo.make, {
          logo: {
            NAME: "WithWrapper",
            VAL: [
              {
                NAME: "ArteVerticalLogo",
                VAL: "HighlightTitle"
              },
              "TopTeaser"
            ]
          }
        });
  var titleComponent;
  if (title !== undefined) {
    switch (title.TAG | 0) {
      case /* Displayed */0 :
          titleComponent = React.createElement(Atom_Text.make, {
                children: Curry._1(Type_String.Teaser.Title.toString, title._0),
                id: Particle_Accessibility.AriaLabelledby.newId(ariaLabelledby, "-title"),
                kind: "h2",
                style: Atom_Text_Ds.makeTopTeaser(undefined, "Title")
              });
          break;
      case /* AccessibilityOnly */1 :
      case /* HoverOnly */2 :
          titleComponent = null;
          break;
      
    }
  } else {
    titleComponent = null;
  }
  var subtitle$1 = subtitle !== undefined ? React.createElement(Atom_Text.make, {
          blockSpace: Molecule_TopTeaser_Css.Content.subtitleSpacer,
          children: Curry._1(Type_String.Teaser.Subtitle.toString, subtitle._0),
          id: Particle_Accessibility.AriaLabelledby.newId(ariaLabelledby, "-subtitle"),
          kind: "h3",
          style: Atom_Text_Ds.makeTopTeaser(undefined, "Subtitle")
        }) : null;
  var description$1 = description !== undefined ? React.createElement(Atom_Row.make, {
          children: React.createElement(Atom_Text.make, {
                children: Curry._1(Type_String.Teaser.Description.toString, description),
                kind: "p",
                style: Atom_Text_Ds.makeTopTeaser(undefined, "Desc"),
                width: Particle_Screen_Constants.oneHundredPctWidth
              }),
          display: Molecule_TopTeaser_Css.Description.display
        }) : null;
  var sticker;
  if (duration !== undefined) {
    var durationLabel = Type_Teaser.Helper.getDurationLabel(minutesLabel, duration);
    sticker = React.createElement(Atom_Column.make, {
          blockSpace: Molecule_TopTeaser_Css.Sticker.blockSpace,
          children: React.createElement(Molecule_Sticker.make, {
                text: durationLabel,
                style: Molecule_Sticker.Molecule_Sticker_Ds.topTeaser,
                position: /* Inherit */3,
                id: Particle_Accessibility.AriaLabelledby.newId(ariaLabelledby, "-duration")
              }),
          display: Molecule_TopTeaser_Css.Sticker.display
        });
  } else {
    sticker = null;
  }
  var tmp$2 = {
    children: null,
    height: match$1.height,
    id: idString,
    justifyContent: Molecule_TopTeaser_Css.Container.justifyContent,
    width: Particle_Screen_Constants.oneHundredPctWidth,
    key: idString
  };
  if (match$1.blockSpace !== undefined) {
    tmp$2.blockSpace = Caml_option.valFromOption(match$1.blockSpace);
  }
  var tmp$3 = {
    srcs: teaser.imageSrc
  };
  if (alt !== undefined) {
    tmp$3.alt = Caml_option.valFromOption(alt);
  }
  var tmp$4 = {
    children: null
  };
  if (elementsAnimation !== undefined) {
    tmp$4.animation = Caml_option.valFromOption(elementsAnimation);
  }
  var tmp$5 = {
    justifyContent: Molecule_TopTeaser_Css.Content.justifyContent,
    alignItems: Particle_Screen_Constants.alignItemsCenter,
    blockSpace: Molecule_TopTeaser_Css.Content.blockSpace,
    width: Particle_Screen_Constants.oneHundredPctWidth,
    maxWidth: Molecule_TopTeaser_Css.Content.maxWidth,
    height: Particle_Screen_Constants.oneHundredPctHeight,
    children: React.createElement(Atom_Row.make, {
          children: null,
          wrap: /* OnOneLine */1
        }, logo, React.createElement(Atom_Column.make, tmp$4, titleComponent, subtitle$1, sticker, React.createElement(Atom_Column.make, {
                  alignItems: Molecule_TopTeaser_Css.alignItems,
                  blockSpace: Molecule_TopTeaser_Css.DescriptionButtons.blockSpace,
                  children: null,
                  innerSpace: Molecule_TopTeaser_Css.ButtonsChildrenRow.innerSpace
                }, description$1, buttons))),
    rules: Molecule_TopTeaser_Css.Content.rules
  };
  if (match$1.contentMinHeight !== undefined) {
    tmp$5.minHeight = Caml_option.valFromOption(match$1.contentMinHeight);
  }
  return React.createElement(Atom_Column.make, tmp$2, React.createElement(Molecule_TopTeaser$Image, tmp$3), React.createElement(Atom_Cell.make, tmp$5));
}

var identifiers = {
  imageElement: "image-element"
};

var make = Molecule_TopTeaser;

export {
  identifiers ,
  playButtonId ,
  $$Image ,
  make ,
}
/* react Not a pure module */
